import { Box, Button, Card, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { PermissionGuard } from '../../../components/PermissionGuard'
import { useNavigate, useParams } from 'react-router-dom'
import SystemCoupons from './SystemCoupons'
import ManualCoupons from './ManualCouponList'
import useResponsive from '../../../hooks/useResponsive';
import { ArrowBack, Cancel, CheckCircle, ContentCopy, Edit } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const CouponList = () => {
  const { isSm } = useResponsive();
  const navigate = useNavigate();
  const {tab} = useParams();
  const [tabValue, setTabValue] = useState('0');
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <Box>
      {/* ===========page title================= */}
      <PageHeaderLayout headerTitle={'Manage Coupons'}>
        <PermissionGuard feature='coupon' permission='canCreate'>
          <Button size='small' variant='contained' onClick={() => navigate('/marketing/coupon/0')} sx={{ textTransform: 'capitalize' }} startIcon={isSm ? '' : <AddCircleIcon />}>
            Add New
          </Button>
        </PermissionGuard>
        <Button size='small' variant='contained' onClick={() => navigate(-1)} sx={{ textTransform: 'capitalize', display: { xs: 'none', sm: 'flex' } }} startIcon={<ArrowBack />}>
          Back
        </Button>
      </PageHeaderLayout>
      <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >

            <Tab value="0" label="System Coupons" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
            <Tab value="1" label="Manual Coupons" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
          </Tabs>
        </Box>
      </Card>
      {tabValue === '0' && <SystemCoupons />}
      {tabValue === '1' && <ManualCoupons />}
    </Box>
  )
}

export default CouponList
